import React from 'react';
import VideoPlayer from './VideoPlayer.jsx';
import VideoPlayerMessageWrapper from './VideoPlayerMessageWrapper.jsx';
import getCroppingQueryParams from '../util/getCroppingQueryParams';

export default class VideoPlayerPlaceholder extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      clicked: false,
    };
  }

  render() {
    const { video, article, csid, videoElementId } = this.props;
    const poster = video.posterUrl
      ? `${video.posterUrl}${getCroppingQueryParams(4)}`
      : '';
    const posterStyle = {
      backgroundImage: `url(${poster})`,
    };

    const placeholder = (
      <div className="video-wrapper" onClick={() => this.setState({ clicked: true })}>
        <div className="avodp">
          <div className="avodp viafree-player x-small">
            <div className="x-play-button-overlay"></div>
            <div className="vjs-poster" style={posterStyle}></div>
            <div className="x-play-button-overlay"></div>
            <button className="vjs-big-play-button" />
          </div>
        </div>
      </div>
    );

    const videoPlayer = (
      <VideoPlayer
        video={video}
        article={article}
        csid={csid}
        inline
        autoplay
        doNotTrackAutoplay
        videoElementId={videoElementId}
      />
    );

    return (
      <VideoPlayerMessageWrapper article={article} video={video}>
        { this.state.clicked ? videoPlayer : placeholder }
      </VideoPlayerMessageWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/VideoPlayerPlaceholder.jsx